function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_target)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 45,
  cy: 45,
  r: 35.1562,
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 70.2422C58.9219 70.2422 70.2422 58.9219 70.2422 45C70.2422 31.0781 58.9219 19.7578 45 19.7578C31.0781 19.7578 19.7578 31.0781 19.7578 45C19.7578 58.9219 31.0781 70.2422 45 70.2422ZM45 23.9766C56.6016 23.9766 66.0234 33.3984 66.0234 45C66.0234 56.6016 56.6016 66.0234 45 66.0234C33.3984 66.0234 23.9766 56.6016 23.9766 45C23.9766 33.3984 33.3984 23.9766 45 23.9766Z",
  fill: "#1B1E31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 60.3281C53.4375 60.3281 60.3281 53.4375 60.3281 45C60.3281 36.5625 53.4375 29.6719 45 29.6719C36.5625 29.6719 29.6719 36.5625 29.6719 45C29.6719 53.4375 36.5625 60.3281 45 60.3281ZM45 33.8906C51.1172 33.8906 56.1094 38.8828 56.1094 45C56.1094 51.1172 51.1172 56.1094 45 56.1094C38.8828 56.1094 33.8906 51.1172 33.8906 45C33.8906 38.8828 38.8828 33.8906 45 33.8906Z",
  fill: "#1B1E31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 80.1562C64.4062 80.1562 80.1562 64.4062 80.1562 45C80.1562 25.5938 64.4062 9.84375 45 9.84375C25.5938 9.84375 9.84375 25.5938 9.84375 45C9.84375 64.4062 25.5938 80.1562 45 80.1562ZM45 14.0625C62.0859 14.0625 75.9375 27.9141 75.9375 45C75.9375 62.0859 62.0859 75.9375 45 75.9375C27.9141 75.9375 14.0625 62.0859 14.0625 45C14.0625 27.9141 27.9141 14.0625 45 14.0625Z",
  fill: "#1B1E31"
}), /*#__PURE__*/React.createElement("path", {
  d: "M45 41.625C44.1049 41.625 43.2464 41.9806 42.6135 42.6135C41.9806 43.2465 41.625 44.1049 41.625 45C41.625 45.8951 41.9806 46.7536 42.6135 47.3865C43.2464 48.0194 44.1049 48.375 45 48.375C45.8951 48.375 46.7535 48.0194 47.3865 47.3865C48.0194 46.7536 48.375 45.8951 48.375 45C48.375 44.1049 48.0194 43.2465 47.3865 42.6135C46.7535 41.9806 45.8951 41.625 45 41.625Z",
  fill: "#1B1E31"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_target",
  x: -4,
  y: 0,
  width: 98,
  height: 98,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})));

var SvgTarget = function SvgTarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Target.d7fda833.svg";
export { ForwardRef as ReactComponent };